import { render } from "./UpdateComponent.vue?vue&type=template&id=788185e6"
import script from "./UpdateComponent.vue?vue&type=script&lang=js"
export * from "./UpdateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__